import { Timestamp } from 'firebase/firestore';

export const formatMessageTime = (timestamp: Timestamp | null): string => {
  if (!timestamp) return '';
  
  const date = timestamp.toDate();
  const now = new Date();
  const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60);

  // If less than 24 hours ago, show time
  if (diffInHours < 24 && now.getDate() === date.getDate()) {
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: 'numeric',
    }).format(date);
  }

  // If within last 7 days, show day name
  if (diffInHours < 24 * 7) {
    return new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date);
  }

  // Otherwise show date
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
  }).format(date);
};

export const formatChatHeaderDate = (timestamp: Timestamp | null): string => {
    if (!timestamp) return 'Offline';
    // Implementation for "Last seen X mins ago" can go here
    return 'Online'; // Placeholder
};
